import React, {useCallback, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {BasicLayout} from '../../modules/Layouts/basicLayout'
import ListaRequisitos from './Components/ListaRequisitos'
import SeriesPendientes from './Components/SeriesPendientes'
import InterruptorVersion from './Components/InterruptorVersion'
import {normativaGetAlistamiento} from '../../actions/normativa/normativa.actions'
import {AlistamientoNormativa} from '../../interfaces/normativa.interface'
import {nombreModalidadCorrelativo, nombreVersionNormativa} from '../../utils/normativa.utils'
import './styles/normativa.css'

const AlistamientoNormativaPage = () => {
  const dispatch = useDispatch()
  const [alistamiento, setAlistamiento] = useState<AlistamientoNormativa | null>(null)
  const [consultado, setConsultado] = useState(false)

  const consultarAlistamiento = useCallback(async () => {
    const respuesta: any = await dispatch(normativaGetAlistamiento())
    setAlistamiento(respuesta ?? null)
    setConsultado(true)
  }, [dispatch])

  useEffect(() => {
    consultarAlistamiento()
  }, [consultarAlistamiento])

  const requisitos = alistamiento?.requisitos ?? []
  const pendientes = requisitos.filter((requisito) => !requisito.cumple).length

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/normativa'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Alistamiento para la normativa 2.0</h3>
      </div>
      <div className='separador'></div>
      <div
        id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6'
        className='w-layout-layout bill-section wf-layout-layout'
      >
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{height: 'auto'}}>
            <div className='w-layout-vflex card-content'>
              {!alistamiento && consultado && (
                <div className='normativa-bloque'>
                  <p className='normativa-texto m'>
                    No se logró obtener el alistamiento de su empresa. Revise su conexión y presione
                    el botón para volver a consultarlo.
                  </p>
                  <button
                    className='m button transparent w-inline-block normativa-boton-corto'
                    onClick={consultarAlistamiento}
                  >
                    <div>Volver a consultar</div>
                  </button>
                </div>
              )}

              {alistamiento && (
                <React.Fragment>
                  <div className='normativa-bloque'>
                    <h3 className='card-title l'>Su empresa</h3>
                    <div className='normativa-resumen'>
                      <div className='normativa-resumen-item'>
                        <p className='normativa-dato'>Nombre comercial</p>
                        <p className='normativa-valor m'>{alistamiento.nombrecomercial}</p>
                      </div>
                      <div className='normativa-resumen-item'>
                        <p className='normativa-dato'>Código de empresa</p>
                        <p className='normativa-valor m'>{alistamiento.codigoempresa}</p>
                      </div>
                      <div className='normativa-resumen-item'>
                        <p className='normativa-dato'>Versión de la normativa</p>
                        <p className='normativa-valor m'>
                          {nombreVersionNormativa(alistamiento.versionactual)}
                        </p>
                      </div>
                      <div className='normativa-resumen-item'>
                        <p className='normativa-dato'>Modalidad de correlativo</p>
                        <p className='normativa-valor m'>
                          {nombreModalidadCorrelativo(alistamiento.tipocorrelativo)}
                        </p>
                      </div>
                    </div>
                    <p className='normativa-texto m'>
                      La modalidad de correlativo que su empresa haya informado al Ministerio de
                      Hacienda debe coincidir con la que aparece aquí. Si no coincide, comuníquese
                      con el equipo de soporte antes de cambiar de versión.
                    </p>
                  </div>

                  <div className='form-separator'></div>

                  <div className='normativa-bloque'>
                    <h3 className='card-title l'>Requisitos del alistamiento</h3>
                    <p className='normativa-texto m'>
                      {pendientes === 0
                        ? 'Su empresa cumple todos los requisitos que se revisan en esta pantalla.'
                        : `Su empresa tiene ${pendientes} ${
                            pendientes === 1 ? 'requisito pendiente' : 'requisitos pendientes'
                          }. Resuélvalos para poder pasar a la versión 2.`}
                    </p>
                    <ListaRequisitos requisitos={requisitos} />
                    <button
                      className='m button transparent w-inline-block normativa-boton-corto'
                      onClick={consultarAlistamiento}
                    >
                      <div>Volver a revisar el alistamiento</div>
                    </button>
                  </div>

                  <div className='form-separator'></div>

                  <SeriesPendientes series={alistamiento.series ?? null} />

                  <div className='form-separator'></div>

                  <InterruptorVersion
                    alistamiento={alistamiento}
                    onVersionCambiada={consultarAlistamiento}
                  />

                  <div className='form-separator'></div>

                  <div className='normativa-acciones'>
                    <Link
                      to={'/normativa'}
                      className='m button transparent w-inline-block'
                      style={{textDecoration: 'none'}}
                    >
                      <div>Revisar de nuevo la información de la normativa 2.0</div>
                    </Link>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default AlistamientoNormativaPage
